import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function GradeBandField({ setGradeBand, className }) {
  return (
    <select
      id="gradeBand"
      className={classNames('form-select', className)}
      required
      defaultValue=""
      onChange={(e) => setGradeBand(e.target.value)}
    >
      <option value="" disabled hidden>
        Select a grade
      </option>
      <option value="prek-2">Pre-K to Grade 2</option>
      <option value="3-5">Grades 3 to 5</option>
      <option value="6-8">Grades 6 to 8</option>
      <option value="9-12">Grades 9 to 12</option>
      <option value="college">College and beyond</option>
    </select>
  );
}

GradeBandField.propTypes = {
  setGradeBand: PropTypes.func.isRequired,
  className: PropTypes.string,
};

GradeBandField.defaultProps = {
  className: null,
};

export default GradeBandField;
